<template>
  <div>
    <!-- 头部 -->
    <Header :title="title" :showBack="true"></Header>

    <!-- 日期选择组件 -->
    <SelectDate v-model:selectDate="selectDate"></SelectDate>

    <!-- 内容 -->
    <div class="nodeManage">
      <van-cell-group>
        <!-- 线路 -->
        <van-cell is-link @click="showLine = true">
          <template #icon>
            <div class="cellIconClass">
              <span class="iconfont iconxianlu1"></span>
            </div>
          </template>
          <template #title>
            <div class="flex">
              <div class="cellTitleClass" style="flex: 1">
                {{ line ? line.text : "暂无数据" }}
              </div>
              <div style="margin: 0 0.2rem">{{ orgLineNameList.length }}条</div>
            </div>
          </template>
        </van-cell>
        <!-- 时间人数 -->
        <!-- @click="onShowLineClassDayCheck" -->
        <!-- <van-cell is-link @click="showLineClassDay = true">
          <template #icon>
            <div class="cellIconClass">
              <van-icon name="clock-o" />
            </div>
          </template>
          <template #title>
            <div class="flex">
              <div class="cellTitleClass" style="flex: 1;">
                {{ lineClassDay ? lineClassDay.ClassTime : "暂无数据" }}
              </div>
              <div style="margin: 0 0.2rem;">
                {{ lineClassDay ? lineClassDay.HandSellCount : 0 }}人
              </div>
            </div>
          </template>
        </van-cell> -->
        <!-- 时间人数 -->
        <van-collapse v-model="activeNames">
          <van-collapse-item name="1">
            <template #icon>
              <div class="cellIconClass">
                <van-icon name="clock-o" />
              </div>
            </template>
            <template #title>
              <div class="flex">
                <div class="cellTitleClass" style="flex: 1">
                  {{ lineClassDay ? lineClassDay.ClassTime : "暂无数据" }}
                </div>
                <div style="margin: 0 0.2rem" v-if="IsShowLineAndClassTotalPerson">
                  {{ lineClassDay ? lineClassDay.HandSellCount : 0 }}人
                </div>
              </div>
            </template>
            <template>
              <div class="timeItem">
                <div class="flex flex-wrap flex-justify-around">
                  <div
                    v-for="(item, index) in classTimeList"
                    :key="index"
                    class="w30 classTimeWrapClass"
                    @click="onClickLineClassDayItem(item)"
                  >
                    <div
                      :class="
                        lineClassDay && lineClassDay.ClassCode == item.ClassCode
                          ? 'classTimeClass classTimeActive'
                          : 'classTimeClass'
                      "
                    >
                      <ul class="flex">
                        <li class="text-bold c000 classTime">
                          {{ item.ClassTime }}
                        </li>
                        <li v-if="[2, 5].indexOf(item.ClassStatusID) > -1">
                          <div class="stopClass">停</div>
                        </li>
                        <li v-else>
                          <div class="openClass">开</div>
                        </li>
                      </ul>
                      <ul class="flex classInfoClass">
                        <li class="flex" v-if="IsShowLineAndClassTotalPerson">
                          <div class="sellTickets">
                            售:<span>{{ item.HandSellCount }}</span>
                          </div>
                          <div class="checkTickets">
                            检:<span>{{ item.CheckedCount }}</span>
                          </div>
                        </li>
                        <li class="vehicleListClass">
                          <div
                            v-if="item.LicensePlateNumberList == null"
                            style="
                              color: red;
                              font-weight: bold;
                              margin-top: 5px;
                            "
                          >
                            未派车
                          </div>
                          <div
                            v-else-if="item.LicensePlateNumbers > 2"
                            style="
                              color: #5f5f5f;
                              font-weight: bold;
                              margin-top: 5px;
                            "
                          >
                            已派{{ item.LicensePlateNumbers }}车
                          </div>
                          <div
                            v-else
                            style="
                              color: #5f5f5f;
                              font-weight: bold;
                              margin-top: 5px;
                            "
                          >
                            {{ item.LicensePlateNumberList }}
                          </div>
                        </li>
                      </ul>
                      <!-- <p
                        class="classInfoClass text-right"
                        style="margin-left: 0.2rem;"
                        v-if="item.HandSellCount > 0"
                      >
                        {{ item.CheckedCount }} / {{ item.HandSellCount }}人
                      </p> -->
                    </div>
                  </div>
                </div>
                <div class="text-right" style="margin-right: 0.2rem">
                  <van-button
                    icon="replay"
                    size="small"
                    type="default"
                    @click="onGetLineClassDay"
                    >刷新</van-button
                  >
                </div>
              </div>
            </template>
          </van-collapse-item>
        </van-collapse>
        <!-- 调度备注 -->
        <van-cell
          v-if="lineClassDay && lineClassDay.Remark"
          icon="comment-circle-o"
          title="调度备注"
          :value="lineClassDay.Remark"
          value-class="cellValueClass"
        />
        <!-- <van-button type="primary" block @click="sendClassMsg">
          班次消息发送
        </van-button> -->
      </van-cell-group>

      <!-- 站点及车辆列表 -->
      <div class="nodeCarList" v-if="lineClassDay">
        <van-tabs
          swipeable
          :ellipsis="false"
          style="z-index: 0"
          v-model="tabactive"
          color="#5470C6"
          @click="tabsClick"
        >
          <!-- 站点 -->
          <van-tab
            :title="'站点(' + startNodeList.length + ')'"
            class="tabNode"
          >
            <!-- <div>
              <van-row>
                <van-col span="12">
                <van-cell
                is-link
                :title="selectStartNodeGroup"
                @click="startNodeShow = true"
                style="
                display: inline-flex;
                align-items: center;
                justify-content: flex-end;
                background: #eee;
                border-radius: 4px;
                margin: 8px 0 8px auto;
                width: fit-content;
                padding: 0;
              "
                /></van-col>
              </van-row>
            </div> -->
           <!-- 筛选栏 -->
            <div style="display: flex; justify-content: flex-end; padding: 8px 12px; background: #f5f5f5;">
              <div 
                class="filter-wrap" 
                style="
                  display: inline-flex;
                  align-items: center;
                  background: #ffffff;
                  border-radius: 12px;
                  box-shadow: 0 2px 6px rgba(0,0,0,0.06);
                  border: 1px solid #e8e8e8;
                  overflow: hidden;
                "
              >
                <span style="padding: 8px 12px; color: #666; font-weight: 500;">筛选：</span>
                <van-row>
                  <van-col span="12">
                    <van-cell
                      is-link
                      :title="selectStartNodeGroup"
                      @click="startNodeShow = true"
                      style="
                        display: inline-flex;
                        align-items: center;
                        justify-content: flex-end;
                        background: #fafafa;
                        border-radius: 0 8px 8px 0;
                        margin: 0;
                        width: fit-content;
                        padding: 0 12px;
                        height: 40px;
                        border-left: 1px solid #eee;
                        white-space: nowrap;
                        flex-direction: row;
                      "
                    />
                  </van-col>
                </van-row>
              </div>
            </div>
            <van-steps direction="vertical" :active="-1">
              <template v-if="startNodeList.length > 0">
                <van-step v-for="(node,index) in startNodeList" v-bind:key="node.GID">
                  <div
                    class="tabNodeItem"
                    :style="{
                      color: $store.state.baseColor,
                    }"
                    :key="index"
                    :id="`box-${index}`"
                  >
                    <van-cell-group @click="onToCheck(node,index)">
                      <!-- 时间、站点 -->
                      <van-cell>
                        <template #title>
                          <van-row class="timeNede">
                            <van-col span="6">
                              <div class="classTime">{{ node.ClassTime }}</div>
                            </van-col>
                            <van-col span="18">
                              <div class="nodeName">
                                {{
                                  node.NodeAlias
                                    ? node.NodeAlias
                                    : node.OriginNodeName
                                }}
                              </div>
                            </van-col>
                            <van-col span="6" v-if="node && node.Remark && node.Remark.length <36">
                              <div style="color:red">
                                ({{ node.Remark }})
                              </div>
                            </van-col>
                          </van-row>
                        </template>
                      </van-cell>
                      <!-- 检票数量 -->
                      <van-cell>
                        <template #title>
                          <van-row>
                            <van-col span="20">
                              <div style="display: flex">
                                <p>
                                  未检:
                                  <span class="textRed">
                                    {{ node.NoCeckedCount }}
                                  </span>
                                </p>
                                &nbsp; /&nbsp;
                                <p>
                                  已检：
                                  <span class="textRed">
                                    {{ node.CheckedTickets }}
                                  </span>
                                </p>
                              </div>
                            </van-col>
                            <van-col
                              span="4"
                              v-if="!node.IsCanSale"
                              :align="'center'"
                            >
                              <span v-if="!node.IsCanSale" class="textRed">
                                停售
                              </span>
                            </van-col>
                          </van-row>
                        </template>
                      </van-cell>
                      <!-- 检票情况 -->
                      <van-cell
                        title="已检未上车"
                        :value="node.CheckedTickets - node.SendPeople"
                        value-class="cellValueClass"
                        v-if="vehicleList.length > 1"
                        :title-style="{ 'text-align': 'left' }"
                      />
                      <van-cell
                        title="已发送"
                        :value="node.SendPeople"
                        value-class="cellValueClass"
                        v-if="vehicleList.length > 1"
                        :title-style="{ 'text-align': 'left' }"
                      />
                      <!-- 车辆信息 -->
                      <van-cell
                        v-for="car in node.IsSendCar"
                        v-bind:key="car.GID"
                      >
                        <template #title>
                          <div :style="{ color: $store.state.baseColor }">
                            {{
                              car.VehicleNo +
                              " (" +
                              car.PassengerSeatCount +
                              "/" +
                              car.beforeNodeSendPeople +
                              "/" +
                              car.PassengerCount +
                              ")" +
                              (car.beforeNodeSendPeople ==
                              car.PassengerSeatCount
                                ? "满"
                                : "") +
                              " " +
                              $moment(
                                IsNewSignInMode
                                  ? car.StartCarTime
                                    ? car.StartCarTime
                                    : car.CreateTime
                                  : car.CreateTime
                              ).format("HH:mm")
                            }}
                          </div>
                        </template>
                      </van-cell>
                    </van-cell-group>

                    <!-- 按钮 -->
                    <van-row>
                      <van-col :span="IsEnableManualNodeSignIn ? 12 : 0">
                        <van-button
                          v-show="IsEnableManualNodeSignIn"
                          block
                          @click="onNodeSignInClick(node)"
                          class="sendCarBtn"
                          :style="{ backgroundColor: 'blue' }"
                        >
                          站点签到
                        </van-button>
                      </van-col>
                      <van-col :span="12">
                        <van-button
                          block
                          @click="onStartCar(node)"
                          :disabled="showWhatValue(node) == '未派车'"
                          class="sendCarBtn"
                          :style="{ backgroundColor: $store.state.baseColor }"
                        >
                          {{ showWhatValue(node) }}
                        </van-button>
                      </van-col>
                      <van-col :span="IsEnableManualNodeSignIn ? 0 : 12">
                        <van-button
                          v-show="!IsEnableManualNodeSignIn"
                          block
                          @click="onToCheck(node,index)"
                          class="sendCarBtn"
                          style="background-color: #f7a33c"
                        >
                          检票
                        </van-button>
                      </van-col>
                    </van-row>
                  </div>
                </van-step>
              </template>
            </van-steps>
          </van-tab>
          <!-- 上下车统计 -->
          <van-tab title="上下车统计" v-if="IsHandheldShowStartArrivalStats">
            <component
              :is="cmpObj.startArrivalStatsCmp"
              v-bind="getStartArrivalStatsCmpProps"
            ></component>
          </van-tab>
          <!-- 车辆 -->
          <van-tab :title="'车辆(' + vehicleList.length + ')'" class="tabCar">
            <van-steps direction="vertical" :active="-1">
              <div v-if="vehicleList.length > 0">
                <van-step v-for="item in vehicleList" v-bind:key="item.GID">
                  <van-panel
                    class="vehicleBox"
                    icon="coupon"
                    :style="{ borderColor: $store.state.baseColor }"
                  >
                    <div slot="header" v-if="!IsNewSignInMode">
                      <van-icon name="coupon" size="0.5rem" />
                      {{ item.VehicleNo }}
                      <van-tag
                        v-if="
                          item.CheckInTime == null &&
                          [1, 2].indexOf(line.lineInfo.CustomMadeLevel) > -1
                        "
                        style="line-height: 0.6rem"
                        type="danger"
                        >未签到</van-tag
                      >
                      <van-tag
                        v-if="
                          item.CheckInTime != null &&
                          [1, 2].indexOf(line.lineInfo.CustomMadeLevel) > -1
                        "
                        type="success"
                        >已签到</van-tag
                      >
                      <!-- <van-tag v-if="item.CheckInTime!=null&&item.DepartTime!=null" type="primary">已发车</van-tag> -->
                      <van-tag
                        type="success"
                        style="margin-left: 80px"
                        size="large"
                      >
                        {{
                          item.PassengerCount
                            ? item.PassengerCount
                            : 0 +
                              (item.PassengerCount == item.PassengerSeatCount
                                ? "满"
                                : "")
                        }}
                      </van-tag>
                    </div>
                    <div slot="header" style="color: #323233" v-else>
                      <div>
                        <van-icon name="coupon" size="0.5rem" />
                        &nbsp;
                        {{
                          item.VehicleNo + "(" + item.PassengerSeatCount + ")"
                        }}
                      </div>
                      <p>
                        车上乘客：{{
                          item.PassengerCount
                            ? item.PassengerCount
                            : 0 +
                              (item.PassengerCount == item.PassengerSeatCount
                                ? "满"
                                : "")
                        }}
                      </p>
                    </div>
                    <div
                      style="
                        color: #323233;
                        display: flex;
                        flex-wrap: wrap;
                        width: 100%;
                      "
                    >
                      <div>
                        <van-icon name="manager" size="0.5rem" />
                        <div style="width: 2.5rem; padding-left: 0.2rem">
                          {{ item.Driver1Name }}
                        </div>
                        <a
                          @click.stop
                          :href="'tel:' + item.Driver1Tel"
                          v-if="item.Driver1Tel"
                        >
                          <van-icon name="phone" size="0.5rem" />
                          {{ item.Driver1Tel }}
                        </a>
                      </div>
                      <div v-if="item.Driver2Name != null">
                        <van-icon name="friends" size="0.5rem" />
                        <div style="width: 2.5rem; padding-left: 0.2rem">
                          {{ item.Driver2Name }}
                        </div>

                        <a
                          @click.stop
                          :href="'tel:' + item.Driver2Tel"
                          v-if="item.Driver2Tel"
                        >
                          <van-icon name="phone" size="0.5rem" />
                          {{ item.Driver2Tel }}
                        </a>
                      </div>
                      <!--跟车员-->
                      <span
                        v-if="
                          ClassVehicleIsShowCarFollower && item.CarFollowersName
                        "
                      >
                        <div v-for="carF in item.CarFollowersName.split(',')">
                          <van-icon name="friends" size="0.5rem" />
                          <div style="width: 2.5rem; padding-left: 0.2rem">
                            跟车员:{{ carF.match(/^([^\(]+)\(/)[1] }}
                          </div>
                          <span v-if="carF.match(/\((\d+)\)/)">
                            <a
                              @click.stop
                              :href="'tel:' + carF.match(/\((\d+)\)/)[1]"
                            >
                              <van-icon name="phone" size="0.5rem" />
                              {{ carF.match(/\((\d+)\)/)[1] }}
                            </a>
                          </span>
                        </div>
                      </span>
                    </div>

                    <div class="footer" slot="footer">
                      <van-row type="flex" justify="space-around">
                        <!-- <van-col span="12" v-if="!item.CheckInTime">
                        <van-button
                          v-if="!item.CheckInTime"
                          type="primary"
                          size="normal"
                          @click="onToCar(item.GID,'DispatchingCar')"
                        >更换</van-button>
                      </van-col>-->
                        <van-col span="12">
                          <van-button
                            v-if="!item.CheckInTime && !IsNewSignInMode"
                            type="primary"
                            size="normal"
                            @click="onToCar(item.GID, 'SignIn')"
                            >车辆签到</van-button
                          >
                          <van-button
                            v-if="
                              IsNewSignInMode &&
                              !lineClassDay.LineIsUseSpecialSendCar
                            "
                            type="primary"
                            size="normal"
                            @click="$toast('功能开发中')"
                            >车辆安检</van-button
                          >
                          <van-button
                            v-if="
                              IsNewSignInMode &&
                              lineClassDay.LineIsUseSpecialSendCar
                            "
                            type="danger"
                            size="normal"
                            @click="onContractReport(item)"
                            >一键报备</van-button
                          >
                          <van-button
                            v-if="
                              item.CheckInTime &&
                              !item.DepartTime &&
                              !IsNewSignInMode &&
                              [1, 2].indexOf(line.lineInfo.CustomMadeLevel) > -1
                            "
                            type="danger"
                            size="normal"
                            @click="onCancelSignIn(item)"
                            >取消签到</van-button
                          >
                        </van-col>
                        <van-col span="12">
                          <van-button
                            type="info"
                            size="normal"
                            @click="toVehicleMap(item)"
                            >车辆定位</van-button
                          >
                          <!-- {{item.CheckInTime?'车辆':''}} -->
                        </van-col>
                        <!-- <van-col span="22" style="margin-top: 0.1rem;">
                        <van-button
                          type="primary"
                          size="normal"
                          block
                          class="flex"
                          style="justify-content: center;align-items: center;"
                          @click="ReadDriverIdCard(item)"
                          >读取司机身份证</van-button
                        >
                      </van-col> -->
                      </van-row>
                    </div>
                  </van-panel>
                </van-step>
              </div>
              <div v-else>
                <van-cell title="暂未派车" size="large" />
              </div>
            </van-steps>
            <van-row type="flex" justify="space-between">
              <van-col span="11">
                <van-button
                  type="primary"
                  size="normal"
                  block
                  style="background-color: #7d6b7a; border: 0"
                  @click="onToCar(null, 'DispatchingCar')"
                  >派车</van-button
                >
              </van-col>
              <van-col
                span="11"
                v-if="
                  [1, 2, 4, 5].indexOf(line.lineInfo.CustomMadeLevel) > -1 &&
                  isShowCyw
                "
              >
                <van-button
                  type="primary"
                  size="normal"
                  block
                  style="background-color: #7d6b7a; border: 0"
                  @click="onContractManage"
                  >报备合同管理</van-button
                >
              </van-col>
            </van-row>
          </van-tab>
          <!-- 发送通知 -->
          <van-tab title="发送通知">
            <div></div>
          </van-tab>
          <!-- 牌照 -->
          <!-- <van-tab :title="'牌照'">
            <van-steps direction="vertical" :active="-1" style="padding: 0;">
              <van-panel style="background-color: #f1f1f1;">
                <p style="margin: 0.2rem;"><b>请确认牌照号</b></p>
                <van-row
                  v-for="(item, i) in vehicleList"
                  :key="i"
                  style="margin-top: 0.1rem;"
                >
                  <van-col span="5" style="margin: 0.1rem;">
                    <p style="font-size: 0.4rem; font-weight: bold;">
                      <span v-if="vehicleList.length > 1"
                        >{{ item.VehicleNo }}牌照号：</span
                      >
                      <span v-else style="line-height: 1.2rem;">牌照号：</span>
                    </p>
                  </van-col>
                  <van-col offset="1" span="15">
                    <div
                      class="flex"
                      style="justify-content: center; align-items: center;"
                    >
                      <p style="margin-right: 0.1rem; width: 1.5rem;">运班字</p>
                      <div class="flex: 1;">
                        <van-field
                          v-model="SignBoardNumberList[i]"
                          placeholder="xxx号"
                        />
                      </div>
                      <p style="margin-left: 0.1rem;">号</p>
                    </div>
                  </van-col>
                </van-row>
                <van-button
                  type="primary"
                  size="normal"
                  block
                  style="margin-top: 0.1rem;"
                  @click="onSignBoardNumberClick()"
                  >确认</van-button
                >
              </van-panel>
            </van-steps>
          </van-tab> -->
        </van-tabs>
      </div>
    </div>

    <!-- 2019年8月15日 18:39:36 还原为使用Picker形式 -->
    <!-- @click-overlay="
      onLineConfirm(
        $refs.linePicker.getValues()[0],
        $refs.linePicker.getIndexes()[0]
      )
    " -->
    <van-popup
      v-model="showLine"
      position="bottom"
      style="height: 100%"
      class="linePopup"
    >
      <van-sticky>
        <van-search
          v-model="searchLineValue"
          placeholder="请输入线路代码或名称"
          show-action
          @cancel="showLine = false"
        />
      </van-sticky>
      <van-pull-refresh
        class="line-pull-refresh"
        v-model="lineRefresh"
        @refresh="onGetCompLine"
        style="background-color: #f1f1f1"
      >
        <!-- 置顶线路 -->
        <div v-if="handlerSearchSetTopList.length != 0">
          <p class="line-title">置顶线路</p>
          <van-cell
            v-for="(item, index) in handlerSearchSetTopList"
            :key="index"
            :title="item.text"
            is-link
            @click="onLineConfirm(item)"
            :class="['line-item', { 'label-bold': line.text === item.text }]"
          >
            <template #title>
              <div class="line-item-title">
                <div
                  class="line-item-top"
                  @click="onSetTop(item, $event, 'delete')"
                >
                  <i class="iconfont iconquxiaozhiding"></i>
                </div>
                <div>
                  {{ item.text }}
                </div>
              </div>
            </template>
            <template #default>
              <div class="line-item-details" v-if="IsShowLineAndClassTotalPerson">
                (<span
                  :class="[{ 'line-item-number': item.lineClassDayCount > 0 }]"
                >
                  {{ item.lineClassDayCount }}
                </span>
                班次、
                <span :class="[{ 'line-item-number': item.passagerCount > 0 }]">
                  {{ item.passagerCount }}
                </span>
                人 )
              </div>
            </template>
          </van-cell>
        </div>
        <!-- 线路 -->
        <div v-if="handlerSearchLineNameList.length != 0">
          <p class="line-title">线路</p>
          <van-cell
            v-for="(item, index) in handlerSearchLineNameList"
            :key="index"
            :title="item.text"
            is-link
            @click="onLineConfirm(item)"
            :class="['line-item', { 'label-bold': line.text === item.text }]"
          >
            <template #title>
              <div class="line-item-title">
                <div
                  class="line-item-top"
                  @click="onSetTop(item, $event, 'add')"
                >
                  <i class="iconfont iconzhiding"></i>
                </div>
                <div>
                  {{ item.text }}
                </div>
              </div>
            </template>
            <template #default>
              <div class="line-item-details" v-if="IsShowLineAndClassTotalPerson">
                (<span
                  :class="[{ 'line-item-number': item.lineClassDayCount > 0 }]"
                >
                  {{ item.lineClassDayCount }}
                </span>
                班次、
                <span :class="[{ 'line-item-number': item.passagerCount > 0 }]">
                  {{ item.passagerCount }}
                </span>
                人 )
              </div>
            </template>
          </van-cell>
        </div>
        <div
          v-if="
            handlerSearchLineNameList.length == 0 &&
            handlerSearchSetTopList.length == 0
          "
          class="line-empty"
        >
          暂无数据
        </div>
      </van-pull-refresh>
      <!-- <van-picker
          :columns="lineNameList"
          show-toolbar
          ref="linePicker"
          :item-height="50"
          :default-index="lineDefaultIndex"
          :visible-item-count="8"
          @cancel="showLine = false"
          @confirm="onLineConfirm"
        >
          <div slot="title">
            <van-search
              v-model="searchLineValue"
              placeholder="请输入线路代码或名称"
              input-align="center"
            />
          </div>
          <div slot="confirm">
            <van-icon name="success" color="orange" size="28" />
          </div>
          <div slot="cancel">
            <van-icon name="cross" color="red" size="28" />
          </div>
        </van-picker> -->
    </van-popup>
    <!-- <van-popup
      v-model="showLineClassDay"
      position="bottom"
      @click-overlay="
        onLineClassDayConfirm(
          $refs.lineclassdayPicker.getValues()[0],
          $refs.lineclassdayPicker.getIndexes()[0]
        )
      "
    >
      <van-picker
        :columns="lineClassDayNameList"
        :default-index="lineClassDayDefaultIndex"
        ref="lineclassdayPicker"
        show-toolbar
        :item-height="50"
        :visible-item-count="8"
        title="班次选择"
        @cancel="showLineClassDay = false"
        @confirm="onLineClassDayConfirm"
      />
    </van-popup> -->

    <van-action-sheet
      v-model="startNodeShow"
      :actions="startNodeActionsGroup"
      @select="onStartNodeGroupSelect"
    />

  </div>
</template>

<script>
// @ is an alias to /src
import Header from "@/components/Header/Header.vue";
import SelectDate from "@/components/selectDate";
import dateCalendarStore from "../stores/dateCalendarStore";

const loadStartArrivalStatsCmp = (name) =>
  import(`@/components/LineClassDay/${name}.vue`); // 上下车统计

export default {
  components: {
    Header,
    SelectDate,
  },
  data() {
    return {
      title: "站务管理", //页面标题
      isShowCyw: window.localStorage.getItem("isShowCyw") !== "false",
      showLine: false,
      // showLineClassDay: false,
      lineClassDayNameList: [],
      // lineDefaultIndex: 0,
      lineClassDayDefaultIndex: 0,
      line: window.localStorage.getItem("line")
        ? JSON.parse(window.localStorage.getItem("line"))
        : null, //选择的线路
      lineClassDay: window.localStorage.getItem("lineClassDay")
        ? JSON.parse(window.localStorage.getItem("lineClassDay"))
        : null, //选择的班次

      showLineClassDayCheck: false, //显示实时班次选择
      selectDate: dateCalendarStore.state.selectDate || new Date(),

      vehicleList: [], //班次车辆司机集合
      startNodeList: [], //上车站点集合
      arrivalNodeList: [], //下车站点集合

      SignBoardNumberList: [], // 牌照号集合

      tabactive: 0, //默认是0 --- 0表示站点页, 1表示车辆
      IsNewSignInMode: this.$utils.getSysParams("IsNewSignInMode") == "1",

      //是否显示线路和班次的总人数
      //IsShowLineAndClassTotalPerson : this.$utils.getSysParams("IsShowLineAndClassTotalPerson") == "1",
      
      //2026-06-22 oys 改为权限位控制       
      IsShowLineAndClassTotalPerson: this.$utils.getRightV2("CywPhone.StationManagement", "IsShowLineAndClassTotalPerson") == true,

      //站务管理页面是否显示已停班的班次
      IsShowStopLineClassDay: this.$utils.getSysParams("IsShowStopLineClassDay") == "1",

      //站务管理是否开启检票后定位当前站点
      IsHandhelShowLocateCurrentNode: this.$utils.getSysParams("IsHandhelShowLocateCurrentNode") == "1", 

      IsEnableManualNodeSignIn:
        this.$utils.getSysParams("IsEnableManualNodeSignIn") == "1",
      ClassVehicleIsShowCarFollower: true, //this.$utils.getSysParams("ClassVehicleIsShowCarFollower") == "1",
      IsHandheldShowStartArrivalStats:
        this.$utils.getSysParams("IsHandheldShowStartArrivalStats") == "1", // 是否显示上下车统计

      cmpObj: {
        startArrivalStatsCmp: "", // 上下车统计组件
      },

      searchLineValue: null,

      lineRefresh: false,
      activeNames: [],
      classTimeList: [], // 班次列表

      orgLineNameList: [], // 线路源数据
      lineNameList: [], // 非置顶数据list
      lineNameSetTopList: [], // 置顶数据list

      // 站务管理新增站点分组筛选
      startNodeActionsGroup: [{ name: "全部" }],
      startNodeShow: false,
      selectStartNodeGroup: "全部",
      startNodeGroup: "",
      startNodeGroupList: [],


    };
  },
  computed: {
    //获取跟车员电话
    getCarFollowersTel(followerName) {
      if (!followerName) {
        return null;
      }
      console.log("aaaaaaaaa" + followerName);
      let regex = /\((\d+)\)/; // 匹配括号中的数字
      let match = followerName.match(regex);
      return match ? match[1] : "";
    },
    classStatusText() {
      return (classStatusID) => {
        let val = "";
        switch (classStatusID) {
          case 2:
            val = "已停售";
            break;
          case 5:
            val = "已停班";
            break;
        }
        return val;
      };
    },
    getStartArrivalStatsCmpProps() {
      return {
        lineClassDayGID: this.lineClassDay.GID,
      };
    },
    handlerSearchSetTopList() {
      return this.lineNameSetTopList.filter((item) => {
        return item.text.includes(this.searchLineValue);
      });
    },
    handlerSearchLineNameList() {
      return this.lineNameList.filter((item) => {
        return item.text.includes(this.searchLineValue);
      });
    },
  },
  watch: {
    // //搜索线路
    // searchLineValue() {
    //   if (this.searchLineValue) {
    //     this.lineNameList = this.$utils.searchByRegExp(
    //       this.searchLineValue,
    //       this.orgLineNameList,
    //       "text,lineCode"
    //     );
    //   } else {
    //     // this.lineNameList = this.orgLineNameList;
    //   }
    // },
    selectDate() {
      if (!this.line) return;
      //获取日班次
      this.onGetLineClassDay();
    },
    //线路更改选择
    line() {
      if (this.line) {
        window.localStorage.setItem("line", JSON.stringify(this.line));
      }
      this.onGetLineClassDay();
    },
    //实时班次选择更改
    lineClassDay() {
      if (this.lineClassDay) {
        console.log("this.lineClassDay", this.lineClassDay);
        window.localStorage.setItem(
          "lineClassDay",
          JSON.stringify(this.lineClassDay)
        );
      }
      this.onGetVehicleDriver();
    },
    async showLine() {
      if (this.showLine) {
        await this.onGetCompLine();
        await this.getUserSetTopList();
        // this.lineNameList.forEach((line, i) => {
        //   if (line.lineInfo.GID == this.line.lineInfo.GID) {
        //     this.lineDefaultIndex = i;
        //   }
        // });
      } else {
        this.searchLineValue = null;
      }
    },
    // 监听是否显示上下车统计，动态引入组件
    IsHandheldShowStartArrivalStats: {
      handler(value) {
        // 启用且未引入该组件时引入
        if (value && !this.cmpObj.startArrivalStatsCmp) {
          loadStartArrivalStatsCmp("StartArrivalNodeStats").then((cmp) => {
            this.cmpObj.startArrivalStatsCmp = cmp.default;
          });
        }
      },
      immediate: true,
    },
  },
  methods: {
    //获取上车点站点分组
    onLineStartNodeNodeGroupNameQuery() {
      this.startNodeActionsGroup = [{ name: "全部" }]
      this.startNodeGroupList = []

      debugger
      this.$http
        .post(
          this.$api.onLineStartNodeNodeGroupNameQuery,
          this.$qs.stringify({
            LineGID: this.line.lineGID,
          })
        )
        .then((res) => {
          if (res.success) {
            this.startNodeGroupList = res.data;
            this.startNodeGroupList.forEach((item) => {
              let needAdd = true;
              this.startNodeActionsGroup.forEach((ng) => {
                if (item.NodeGroup == ng.name) {
                  needAdd = false;
                }
              });
              if (needAdd) {
                this.startNodeActionsGroup.push({
                  name: item.NodeGroup,
                });
              }
            });
          }
        });
    },

    //上车站点分组选择
    onStartNodeGroupSelect(item) {
      debugger
      this.selectStartNodeGroup =
        item.name == "全部" ? "全部" : item.name;
      if (item.name == "全部") {
        this.startNodeGroup = "";
        this.onGetStartNode();
      } else {
        debugger
        this.startNodeGroup = item.name;
        this.onGetStartNode();
      }
      this.startNodeShow = false;
    },

    // 返回页面时执行
    activated() {
      debugger

      // 2026-06-03 oys 兼容安卓14，安卓14不支持smooth滚动，try catch降级处理
      let id = sessionStorage.getItem('backToId');
      if (id) {
        setTimeout(() => {
          let el = document.getElementById(id);
          if (el) {
            //el.scrollIntoView({ behavior: 'smooth', block: 'start' });
            el.scrollIntoView({ block: 'start' });
          }
          sessionStorage.removeItem('backToId');
        }, 100);
      }
    },

    // ------------------------------------------------------ 置顶相关
    // 设置置顶
    onSetTop(data, e, type) {
      e.stopPropagation();
      let list = this.$utils.getAdminUserConfig("LineFavorites");
      let adminInfo = JSON.parse(localStorage.getItem("adminInfo"));

      if (type == "add") {
        if (list.length != 0) {
          list.forEach((item) => {
            item.OrderByNo += 1;
          });
        }
        list.unshift({
          LineGID: data.lineGID,
          OrderByNo: 0,
        });
      } else if (type == "delete") {
        list = list.filter((item) => {
          return item.LineGID != data.lineGID;
        });
      }
      let params = {
        UserGID: adminInfo.GID,
        ConfigKey: "LineFavorites",
        ConfigValue: JSON.stringify(list),
      };
      this.$http
        .post(this.$api.SysUserSysUserConfigSave, this.$qs.stringify(params))
        .then((res) => {
          if (res.success) {
            setTimeout(async () => {
              await this.getUserInfo();
              await this.getUserSetTopList();
            }, 500);
          }
        });
    },

    // 获取置顶数据
    getUserSetTopList() {
      let temp = [];
      this.lineNameSetTopList = [];
      let list = this.$utils.getAdminUserConfig("LineFavorites");
      list.forEach((item) => {
        this.orgLineNameList.forEach((i) => {
          if (item.LineGID == i.lineGID) {
            temp.push(i);
          }
        });
      });
      this.lineNameSetTopList = temp;
      // 筛选非置顶数据
      let arr = temp.map((item) => item.lineGID);
      this.lineNameList = this.orgLineNameList.filter(
        (item) => !arr.includes(item.lineGID)
      );
    },

    // 获取用户数据
    getUserInfo() {
      return new Promise((resolve, reject) => {
        let params = {
          _Authorization: window.localStorage.getItem("_cyw_token"),
        };
        this.$http
          .post(this.$api.getUserInfo, this.$qs.stringify(params))
          .then((res) => {
            if (res.success) {
              window.localStorage.setItem(
                "adminUserConfig",
                JSON.stringify(res.data.SysUserConfig)
              );
              resolve(true);
            }
          });
      });
    },
    // ---------------------------

    //站点签到
    onNodeSignInClick(node) {
      //如果只有一辆车,直接签到该车,多辆车提示选择
      if (this.vehicleList.length <= 0) {
        this.$toast.fail("无可签到车辆,请先派车!");
      } else {
        window.localStorage.setItem(
          "lineClassDayStratNode",
          JSON.stringify(node)
        );
        this.$router.push({
          path: "NodeSignIn",
        });
      }
    },
    //前往班次消息发送选择
    sendClassMsg() {
      window.localStorage.setItem(
        "startNodeList",
        JSON.stringify(this.startNodeList)
      );
      window.localStorage.setItem(
        "arrivalNodeList",
        JSON.stringify(this.arrivalNodeList)
      );
      this.$router.push({
        path: "SendClassMsg",
      });
    },
    //一键报备
    onContractReport(vehicle) {
      this.$dialog
        .confirm({
          message: "确定要对车辆" + vehicle.VehicleNo + "进行报备吗？",
        })
        .then(() => {
          let params = {
            LineClassDayGID: this.lineClassDay.GID,
            ModifyGID: JSON.parse(window.localStorage.getItem("adminInfo")).GID,
            ModifyCode: JSON.parse(window.localStorage.getItem("adminInfo"))
              .UserCode,
            ModifyName: JSON.parse(window.localStorage.getItem("adminInfo"))
              .UserName,
            //LineDayClassStationGID: this.node.NodeGID,
            //StaffCount: this.staffCount,
            VehicleGIDList: vehicle.VehicleGID,
            CustomMadeLevel: this.lineClassDay.CustomMadeLevel,
          };
          this.$http
            .post(this.$api.onContractReport, this.$qs.stringify(params))
            .then((res) => {
              if (res.success) {
                this.$toast.success("报备请求成功");
              }
            });
        })
        .catch(() => {
          // on cancel
        });
    },
    onLineConfirm(value) {
      this.showLine = false;
      this.line = value;
      //this.lineDefaultIndex = index;
      //this.onClickLineNav(index);
    },
    // onLineClassDayConfirm(value, index) {
    //   if (value) {
    //     this.showLineClassDay = false;
    //     this.lineClassDayDefaultIndex = index;
    //     this.onClickLineClassDayItem(value.data);
    //   }
    // },

    //班次站点显示什么按钮
    showWhatValue(node) {
      if (this.vehicleList.length <= 0) {
        return "未派车";
      } else if (node.IsSendCar.length < this.vehicleList.length) {
        if (node.IsSendCar.length == 0) {
          return "发车";
        } else {
          return "修改/发车";
        }
      } else if (node.IsSendCar.length === this.vehicleList.length) {
        return "修改";
      }
    },
    //显示线路及班次选择
    onShowLineClassDayCheck() {
      this.showLineClassDayCheck = true;
    },
    //实时班次选择
    onClickLineClassDayItem(data) {
      //this.lineClassDay = data.lineClassDayInfo;
      this.lineClassDay = data;
      this.showLineClassDayCheck = false;
      this.activeNames = [];
    },
    //查询车辆位置
    toVehicleMap(item) {
      var vehicleGIDList = "";
      var preview = null;
      if (item && item.VehicleGID) {
        vehicleGIDList = item.VehicleGID;
        preview = {
          VehicleGID: item.VehicleGID,
          VehicleNo: item.VehicleNo,
          PassengerSeatCount: item.PassengerSeatCount,
          Driver1Name: item.Driver1Name,
          Driver1Tel: item.Driver1Tel,
          Driver2Name: item.Driver2Name,
          Driver2Tel: item.Driver2Tel,
        };
      } else {
        this.vehicleList.forEach((v, index) => {
          if (index != 0) {
            vehicleGIDList += ",";
          }
          vehicleGIDList += v.VehicleGID;
        });
      }
      if (this.lineClassDay) {
        window.localStorage.setItem(
          "lineClassDay",
          JSON.stringify(this.lineClassDay)
        );
      }
      if (preview) {
        window.localStorage.setItem(
          "vehicle-map-preview-info",
          JSON.stringify(preview)
        );
      }
      this.$router.push({
        path: "VehicleMap",
        query: {
          VehicleGIDList: vehicleGIDList,
          entry: "vehicleTab",
        },
      });
    },
    //取消签到
    onCancelSignIn(Vehicle) {
      this.$dialog
        .confirm({
          message: "确定要对车辆" + Vehicle.VehicleNo + "取消签到吗？",
        })
        .then(() => {
          if (Vehicle.DepartTime != null) {
            this.$toast.fail("已经发车车辆不能修改");
            return;
          }
          Vehicle.CheckInTime = null;
          Vehicle.CheckInOperGID = null;
          Vehicle.VehicleCheckInGeocoder = null;
          Vehicle.GPSErrorMsg = null;
          Vehicle.CheckImgPath = null;
          Vehicle.CheckResult = [];
          Vehicle.ModifyGID = JSON.parse(
            window.localStorage.getItem("adminInfo")
          ).GID;
          Vehicle.ModifyCode = JSON.parse(
            window.localStorage.getItem("adminInfo")
          ).UserCode;
          Vehicle.ModifyName = JSON.parse(
            window.localStorage.getItem("adminInfo")
          ).UserName;
          let params = {
            _JsonText: JSON.stringify(Vehicle),
          };
          this.$http
            .post(
              this.$api.onLineClassDayVehicleDriverCancelSign,
              this.$qs.stringify(params)
            )
            .then((res) => {
              if (res.success) {
                this.$toast.success("车辆取消签到成功");
                //this.$router.go(-1);
              }
            });
        })
        .catch(() => {
          // on cancel
        });
    },
    //报备合同管理
    onContractManage() {
      this.$router.push({
        path: "ContractManage",
      });
    },
    //发车
    onStartCar(node) {
      window.localStorage.setItem(
        "lineClassDayStratNode",
        JSON.stringify(node)
      );
      if (node.CheckedTickets > 0) {
        this.$dialog
          .confirm({
            message: "发车前，请确认车上牌照号及司机身份证信息是否一致",
          })
          .then(() => {
            this.OnStartCarFun(node);
          });
      } else {
        this.OnStartCarFun(node);
      }
    },
    OnStartCarFun(node) {
      //2019-11-04  通过参数 IsNewSignInMode 判断是否开启新签到模式
      if (this.IsNewSignInMode) {
        window.localStorage.setItem(
          "ValuePeople",
          node.CheckedTickets - node.SendPeople
        );
        //如果多辆车 进入车辆选择
        if (this.vehicleList.length > 1) {
          this.$router.push({
            path: "SelectVehicle",
          });
        } else {
          window.localStorage.setItem(
            "checkVehicle",
            JSON.stringify(this.vehicleList[0])
          );
          this.$router.push({
            path: "SignInPage",
          });
        }
      } else {
        this.$router.push({
          path: "NodeStartCar",
          query: {
            ValuePeople: node.CheckedTickets - node.SendPeople,
          },
        });
      }
    },
    //车辆签到
    onToCar(GID, type) {
      this.$router.push({
        path: "LineClassDayVehicleDriver",
        query: {
          IsCheck: type,
          GID: GID,
        },
      });
    },
    //进入检票
    onToCheck(node, index) {
      debugger
      if (this.IsHandhelShowLocateCurrentNode) {
        // 保存点击的元素id
        sessionStorage.setItem('backToId', `box-${index}`)
      }

      window.localStorage.setItem(
        "lineClassDayStratNode",
        JSON.stringify(node)
      );
      window.localStorage.setItem(
        "vehicleList",
        JSON.stringify(this.vehicleList)
      );
      let lineClassDayCheckedCount =
        this.lineClassDay.CheckedCount - node.CheckedTickets;
      window.localStorage.setItem(
        "lineClassDayCheckedCount",
        lineClassDayCheckedCount
      );
      this.$router.push({
        path: "TicketCheck",
      });
    },
    //获取公司线路
    onGetCompLine() {
      return new Promise((resolve, reject) => {
        this.orgLineNameList = [];
        let params = {
          OrganizationGID: JSON.parse(window.localStorage.getItem("adminInfo"))
            .OrganizationGID,
          QueryDate: this.$moment(this.selectDate).format("YYYY-MM-DD"),
        };
        this.$http
          .post(this.$api.getGetCompLine, this.$qs.stringify(params))
          .then((res) => {
            if (res.success) {
              res.data.forEach((item, i) => {
                if (item.LineIsEnabled && item.IsEnabled) {
                  this.orgLineNameList.push({
                    text: item.LineName,
                    keyID: item.LineGID,
                    index: i,
                    lineInfo: item,
                    lineGID: item.LineGID,
                    lineCode: item.LineCode,
                    lineClassDayCount: item.LineClassDayCount,
                    passagerCount: item.PassagerCount,
                  });
                }
              });
              resolve(true);
              if (res.data.length > 0) {
                if (this.line) {
                  console.log(this.line, "aaaaa");
                  let info = null;
                  this.orgLineNameList.forEach((linec) => {
                    if (linec.lineInfo.GID == this.line.lineInfo.GID) {
                      info = linec;
                    }
                  });
                  info
                    ? (this.line = info)
                    : (this.line = this.orgLineNameList[0]);
                } else {
                  this.line = this.orgLineNameList[0];
                  // this.lineDefaultIndex = 0;
                  return;
                }
              } else {
                this.line = null;
              }
              if (this.lineRefresh) {
                this.lineRefresh = false;
              }
            }
          });
      });
    },
    //获取实时班次
    onGetLineClassDay() {
      if (!this.line) {
        this.lineClassDay = null;
        this.$toast("没有选择线路");
        return;
      }
      console.log(this.lineClassDay, "day");
      this.lineClassDayNameList = [];

      //this.line.children = [];
      let params = {
        LineGIDList: this.line.lineGID,
        OrganizationGID: JSON.parse(window.localStorage.getItem("adminInfo"))
          .OrganizationGID,
        BeginDate: this.$moment(this.selectDate).format("YYYY-MM-DD"),
        EndDate: this.$moment(this.selectDate).format("YYYY-MM-DD"),
        CompGID: JSON.parse(window.localStorage.getItem("adminInfo")).CompGID,
      };
      this.$http
        .post(this.$api.getLineClassDay, this.$qs.stringify(params))
        .then((res) => {
          if (res.success) {
            res.data.forEach((item, idx) => {
              if (item.LicensePlateNumberList !== null) {
                let LicensePlateNumbers =
                  item.LicensePlateNumberList.split(",").length;
                this.$set(item, "LicensePlateNumbers", LicensePlateNumbers);
              }
              // this.line.children.push({
              //   text:
              //     item.ClassTime +
              //     "(" +
              //     (item.LicensePlateNumberList
              //       ? item.LicensePlateNumberList
              //       : "未派车") +
              //     ")",
              //   lineClassDayInfo: item,
              //   id: item.GID,
              //   //disabled: item.ClassStatusID == 2
              // });
              let noList =
                item.LicensePlateNumberList == null
                  ? "未派车"
                  : item.LicensePlateNumberList;
              let status = this.classStatusText(item.ClassStatusID);
              this.lineClassDayNameList.push({
                text: item.ClassTime + "(" + noList + ")" + status,
                keyID: item.GID,
                classtime: item.ClassTime,
                ClassStatusID: item.ClassStatusID,
                index: idx,
                data: item,
              });

              //oys 2026-01-05 11:53 [826] 【手持机页面】增加参数，站务管理界面是否显示已停班的班次，停售班次不受参数控制
              //this.classTimeList = res.data;
              debugger
              //站务管理页面是否显示已停班的班次
              if(this.IsShowStopLineClassDay){
                this.classTimeList = res.data;
              }else{
                this.classTimeList = res.data
                    .filter(function(item) {
                      // filter 也需用普通函数，兼容旧环境
                      return item.ClassStatusID != 5;
                    })
              }

            });
            if (this.lineClassDay) {
              let info = null;
              this.lineClassDayNameList.forEach((items) => {
                if (this.lineClassDay.GID == items.keyID) {
                  info = items.data;
                  this.lineClassDayDefaultIndex = items.index;
                }
              });
              if (!info) {
                this.lineClassDayNameList.forEach((items) => {
                  if (this.lineClassDay.ClassTime == items.classtime) {
                    info = items.data;
                    this.lineClassDayDefaultIndex = items.index;
                  }
                });
              }
              this.lineClassDay = info;
            }
            if (res.data.length > 0) {
              if (!this.lineClassDay) {
                for (let i = 0; i < this.lineClassDayNameList.length; i++) {
                  let item = this.lineClassDayNameList[i];
                  let classdatetime =
                    this.$moment(item.data.ClassDate).format("YYYY-MM-DD") +
                    "  " +
                    item.data.ClassTime;
                  classdatetime =
                    this.$moment(classdatetime).format("YYYY-MM-DD HH:mm");
                  if (
                    this.$moment().diff(
                      this.$moment(classdatetime),
                      "minutes"
                    ) <= 0
                  ) {
                    this.lineClassDay = item.data;
                    this.lineClassDayDefaultIndex = i;
                    return;
                  }
                }
              }
              if (!this.lineClassDay) {
                this.lineClassDay = this.lineClassDayNameList[0].data;
                this.lineClassDayDefaultIndex = 0;
              } else {
                //this.onGetVehicleDriver();
              }
            } else {
              this.lineClassDay = null;
              this.classTimeList = [];
            }
          }
        });
    },

    // 获取下车点
    onGetArrivalNode() {
      this.$http
        .post(this.$api.getArrivalNode, {
          LineClassDayGID: this.lineClassDay.GID,
        })
        .then((res) => {
          if (res.success) {         
            //this.arrivalNodeList = res.data;

            res.data.forEach((item) => {
              if (item.HandheldManageIsShowThisNode == 1) {
                this.arrivalNodeList.push(item);
              }
            });

          }
        });
    },

    //获取班次上车站点 & 获取是否发车 & 获取检票及未检票人数
    onGetStartNode() {
      if (!this.lineClassDay) {
        return;
      }
      this.startNodeList = [];
      let params = {
        LineClassDayGID: this.lineClassDay.GID,
        StartNodeGroup: this.startNodeGroup
      };
      this.$http
        .post(this.$api.getStartNode, this.$qs.stringify(params))
        .then((res) => {
          if (res.success) {
            console.log(res);
            this.$http
              .post(
                this.$api.getLineClassDayDepartureRecord,
                this.$qs.stringify(params)
              )
              .then((res2) => {
                if (res2.success) {
                  console.log(res2, "res2");
                  //获取到发车记录 统计每辆车上的人数
                  this.vehicleList.forEach((v) => {
                    v.PassengerCount = 0;
                  });
                  res2.data.forEach((rec) => {
                    this.vehicleList.forEach((vehicle) => {
                      if (rec.VehicleGID === vehicle.VehicleGID) {
                        vehicle.PassengerCount += rec.PassengerCount;
                      }
                    });
                  });

                  res.data.forEach((node, index) => {
                    //站点已经发送人数
                    node.SendPeople = 0;
                    //站点已经发送车辆
                    node.IsSendCar = [];
                    //站点未发送车辆
                    res2.data.forEach((item) => {
                      if (node.NodeGID == item.StartNodeGID) {
                        item.beforeNodeSendPeople = 0;
                        for (let j = 0; j <= index; j++) {
                          res2.data.forEach((items) => {
                            if (
                              res.data[j].NodeGID == items.StartNodeGID &&
                              items.VehicleGID == item.VehicleGID
                            ) {
                              item.beforeNodeSendPeople += items.PassengerCount;
                            }
                          });
                        }
                        if (
                          (item.StartCarTime ||
                            (!item.StartCarTime && !item.SignInOperTime)) &&
                          this.IsNewSignInMode
                        ) {
                          node.IsSendCar.push(item);
                        }
                        if (
                          ((item.PassengerCount >= 0 &&
                            !item.SignInOperTime &&
                            !item.StartCarTime) ||
                            item.StartCarTime) &&
                          !this.IsNewSignInMode
                        ) {
                          node.IsSendCar.push(item);
                        }
                        node.SendPeople += item.PassengerCount;
                      }
                    });
                  });
                  
                  // res.data.forEach((item) => {
                  //   if (item.HandheldManageIsShowThisNode == 1) {
                  //     this.startNodeList.push(item);
                  //   }
                  // });

                  // //oys 2025-11-04 不改接口返回数据，前端做排序，避免影响其他业务
                  // //如果站点发车时间相同，则按照排序序号做排序  OrderByNo
                  //  this.startNodeList = res.data
                  // .filter((item) => item.HandheldManageIsShowThisNode == 1)
                  // .sort((a, b) => {
                  //   // 第一步：按 ClassTime 升序排序（数字类型直接相减）
                  //   if (a.ClassTime !== b.ClassTime) {
                  //     return a.ClassTime - b.ClassTime;
                  //   }
                  //   // 第二步：ClassTime 相同，按 OrderByNo 升序排序
                  //   return a.OrderByNo - b.OrderByNo;
                  // });

                  debugger
                  // 旧版本兼容写法：普通函数 + 明确 return + 类型处理
                  const currentDate = this.$moment(new Date()).format("YYYY-MM-DD")
                  this.startNodeList = res.data
                    .filter(function(item) {
                      // filter 也需用普通函数，兼容旧环境
                      return item.HandheldManageIsShowThisNode == 1;
                    })
                    .sort(function(a, b) {
  
                    // 第一步：按 ClassTime 升序排序（日期对比时间戳）
                    if (a.ClassTime !== b.ClassTime) {
                      return new Date(currentDate + " " + a.ClassTime).getTime() >
                      new Date(currentDate + " " + b.ClassTime).getTime()
                      ? 1
                      : -1;
                      //return a.ClassTime - b.ClassTime;
                    }
                    // 第二步：ClassTime 相同，按 OrderByNo 升序排序
                    return a.OrderByNo - b.OrderByNo;

                    });

                    if(this.IsHandhelShowLocateCurrentNode){
                       this.activated(); // 站点排序后，滚动到之前点击的站点位置
                    }
                }
              });
          }
        });
    },
    //获取班次车辆信息
    onGetVehicleDriver() {
      if (!this.lineClassDay) {
        return;
      }
      this.vehicleList = [];
      let params = {
        LineClassDayGID: this.lineClassDay.GID,
      };
      this.$http
        .post(this.$api.getVehicleDriver, this.$qs.stringify(params))
        .then((res) => {
          if (res.success) {
            this.vehicleList = res.data;
            this.SignBoardNumberList = [];
            this.vehicleList.forEach((item) => {
              this.SignBoardNumberList.push(item.SignBoardNumber);
            });
            //获取上车站点
            this.onGetStartNode();
            // 获取下车点
            this.onGetArrivalNode();
            //获取上车站点分组
            this.onLineStartNodeNodeGroupNameQuery();
          }
        });
    },
    // 确认牌照号
    onSignBoardNumberClick() {
      if (this.vehicleList.length <= 0) {
        this.$toast("请先派车");
        return false;
      }
      let isChange = false;
      this.vehicleList.forEach((item, i) => {
        if (!this.SignBoardNumberList[i]) {
          return false;
        }
        if (
          this.vehicleList[i].SignBoardNumber != this.SignBoardNumberList[i]
        ) {
          isChange = true;
          return false;
        }
      });
      if (isChange) {
        this.$dialog
          .confirm({
            message: "牌照号与系统不一致，是否确认保存？",
          })
          .then(() => {
            this.vehicleList.forEach((item, i) => {
              this.vehicleList[i].SignBoardNumber = this.SignBoardNumberList[i];
            });
            let params = {
              LineClassDayGID: this.lineClassDay.GID,
              VehicleDriverJson: JSON.stringify(this.vehicleList),
              LineClassDayState: 0,
              IsCompanyVehicleDeployAdd: false,
              OperGID: JSON.parse(window.localStorage.getItem("adminInfo")).GID,
              OperCode: JSON.parse(window.localStorage.getItem("adminInfo"))
                .UserCode,
              OperName: JSON.parse(window.localStorage.getItem("adminInfo"))
                .UserName,
              IsUpdateSignBoardNumber: true,
            };
            this.$http
              .post(
                this.$api.onLineClassDayVehicleDriverBatchSave,
                this.$qs.stringify(params)
              )
              .then((res) => {
                console.log("res", res);
                this.$toast("修改牌照号成功");
              });
          });
      } else {
        this.$toast("确认成功");
      }
    },
    // 读取司机身份证
    ReadDriverIdCard(item) {
      this.$router.push({
        path: "ReadIdCard",
        query: {
          vehicle: item,
        },
      });
    },
    tabsClick(name, title) {
      if (title == "发送通知") {
        this.sendClassMsg();
      }
    },
  },
  mounted: async function () {
    await this.onGetCompLine();
    // if (this.lineClassDay) {
    //   this.onGetVehicleDriver();
    // }
    this.tabactive = this.$route.params.tabactive; // 根据传参决定显示站点页还是车辆页
  },
  // 首页进入初始化仓库
  beforeRouteEnter(to, from, next) {
    if (from.path == "/") {
      dateCalendarStore.commit("initializeState", {
        selectDateIndex: 0,
        caldendarDefaultDate: new Date(),
        selectDate: new Date(),
        dateList: [],
      });
    }
    next();
  },
};
</script>

<style scoped lang="less">
.nodeManage {
  padding: 0 10px;

  .timeItem {
    .classTimeWrapClass {
      padding: 0.2rem 0;
      box-sizing: border-box;

      &:last-child:nth-child(3n-1) {
        margin-right: calc(30% + 10% / 3);
      }

      &:last-child:nth-child(3n-2) {
        margin-right: calc(60% + 20% / 3);
      }

      .classTimeClass {
        border-radius: 5px;
        background-color: #f7f6f6;
        padding: 0.2rem;
        height: 100%;
        box-sizing: border-box;
        box-shadow: 1px 3px 5px 2px #d8d8d8;

        .classTime {
          flex: 1;
          font-size: 0.55rem;
        }

        .vehicleListClass {
          flex: 1;
        }

        .classInfoClass {
          flex-direction: column;
          font-size: 0.35rem;
        }
      }

      .classTimeActive {
        border: 1px solid #f5ab4a;
      }

      // 停班
      .stopClass {
        padding: 0.03rem 0.05rem;
        background: red;
        border-radius: 5px;
        color: white;
        font-size: 0.35rem;
      }

      .openClass {
        padding: 0.03rem 0.05rem;
        background: #70b603;
        border-radius: 5px;
        color: white;
        font-size: 0.35rem;
      }

      // 售票
      .sellTickets {
        color: #5f5f5f;
        margin-right: 20px;

        & > span {
          font-weight: bold;
          color: #0d0dfe;
        }
      }

      .checkTickets {
        color: #5f5f5f;

        & > span {
          font-weight: bold;
          color: #f5a43a;
        }
      }
    }
  }

  .nodeCarList {
    // 站点
    .tabNode {
      .tabNodeItem {
        border: 0.0625rem solid;
        border-radius: 0.15625rem;
        overflow: hidden;

        .van-cell-group .van-cell::after {
          border-bottom: 1px solid #ccc;
        }

        .van-cell-group .van-cell {
          font-size: 0.5rem;
        }

        .timeNede {
          display: flex;
          align-items: center;

          .classTime {
            font-size: 0.56rem;
            font-weight: 700;
          }

          .nodeName {
            font-size: 0.44rem;
          }
        }

        .textRed {
          color: red;
        }

        .sendCarBtn {
          color: white;
          border: 0;
          font-size: 0.5rem;
          border-radius: 0;
        }
      }
    }

    // 车辆
    .tabCar {
      .vehicleBox {
        border: 0.03125rem solid;
        padding: 0.3125rem 0.3125rem 0 0.3125rem;
      }

      .vehicleBox div {
        display: flex;
        justify-content: space-between;
        line-height: 0.8rem;
      }

      .vehicleBox .van-icon {
        line-height: 0.8rem;
        color: #ccc;
      }

      .vehicleBox .van-panel__footer {
        display: flex;
        justify-content: space-between;
      }

      .vehicleBox .footer {
        overflow: hidden;
        width: 100%;
      }

      .vehicleBox .footer .van-row {
        width: 100%;
      }
    }
  }

  .cellIconClass {
    margin-right: 0.2rem;
  }

  .cellTitleClass {
    font-size: 0.45rem;
    color: #323233;
    font-weight: bolder;
    text-align: left;
  }

  .cellValueClass {
    font-size: 16px;
    color: #323233;
  }
}

// 线路弹出层
.linePopup {
  display: flex;
  flex-direction: column;

  .van-cell::after {
    border-bottom: 1px solid #ccc;
  }

  .label-bold {
    .van-cell__title {
      font-weight: bold;
    }
  }

  .line-pull-refresh {
    flex: 1;
    overflow-y: auto;

    .line-title {
      text-align: left;
      font-size: 0.32rem;
      color: #969799;
      padding: 2px 10px;
    }

    .line-item {
      .line-item-title {
        display: flex;

        .line-item-top {
          display: flex;
          justify-content: center;
          align-items: center;
          margin-right: 0.2rem;
          padding: 0 0.1rem;

          .iconfont {
            color: #5f5f5f;
            font-size: 0.5rem;
          }
        }

        .line-item-top:active {
          background-color: #9e9e9ea2;
          border-radius: 5px;
        }
      }

      .line-item-details {
        margin-right: 0.2rem;

        .line-item-number {
          color: orange;
          font-weight: 700;
          font-size: 0.42rem;
        }
      }

      .van-cell__title {
        text-align: left;
      }
    }

    .line-empty {
      padding: 10px 0;
    }
  }
}

// 日期模式1样式
// .date-content {
//   line-height: 46px;
//   font-size: 0.32rem;
//   background-color: #fff;
//   margin-bottom: 0.15rem;
// }
// .date-content .date-content-date {
//   width: 50%;
//   text-align: center;
//   float: left;
//   font-size: 0.35rem;
//   font-weight: 600;
// }

// .date-content .date-content-left {
//   float: left;
//   padding-left: 5%;
// }

// .date-content .date-content-right {
//   text-align: right;
//   float: right;
//   padding-right: 5%;
// }
</style>
